export default "/images/4d74800b20a12957d96d67977d5de333.png";